export default __webpack_public_path__ + "static/media/delete.77b842e0.svg";